import { MutationTree } from 'vuex';
import { State } from './state';
import { ColorpickerMutationTypes as MutationTypes } from './mutation-types';

export type Mutations<S = State> = {
  [MutationTypes.SET_COLORPICKER_BODY](state: S, payload: string | null): void;
  [MutationTypes.SET_COLORPICKER_EDGE](state: S, payload: string | null): void;
  [MutationTypes.SET_COLORPICKER_EDGE_GLOSINESS](state: S, payload: string | null): void;
  [MutationTypes.SET_COLORPICKER_EDGE_METALNESS](state: S, payload: string | null): void;
  [MutationTypes.SET_COLORPICKER_THREAD](state: S, payload: string | null): void;
  [MutationTypes.SET_COLORPICKER_INSIDE](state: S, payload: string | null): void;
  [MutationTypes.SET_COLORPICKER_TACK](state: S, payload: string | null): void;
}

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.SET_COLORPICKER_BODY](state: State, payload: string) {
    state.colorpickerBody = payload;
    log(MutationTypes.SET_COLORPICKER_BODY, payload)
  },
  [MutationTypes.SET_COLORPICKER_EDGE](state: State, payload: string) {
    state.colorpickerEdge = payload;
    log(MutationTypes.SET_COLORPICKER_EDGE, payload)
  },
  [MutationTypes.SET_COLORPICKER_EDGE_GLOSINESS](state: State, payload: string) {
    state.colorpickerEdgeGlosiness = payload;
    log(MutationTypes.SET_COLORPICKER_EDGE_GLOSINESS, payload)
  },
  [MutationTypes.SET_COLORPICKER_EDGE_METALNESS](state: State, payload: string) {
    state.colorpickerEdgeMetalness = payload;
    log(MutationTypes.SET_COLORPICKER_EDGE_METALNESS, payload)
  },
  [MutationTypes.SET_COLORPICKER_THREAD](state: State, payload: string) {
    state.colorpickerThread = payload;
    log(MutationTypes.SET_COLORPICKER_THREAD, payload)
  },
  [MutationTypes.SET_COLORPICKER_INSIDE](state: State, payload: string) {
    state.colorpickerInside = payload;
    log(MutationTypes.SET_COLORPICKER_INSIDE, payload)
  },
  [MutationTypes.SET_COLORPICKER_TACK](state: State, payload: string) {
    state.colorpickerTack = payload;
    log(MutationTypes.SET_COLORPICKER_TACK, payload)
  },
};

const log = (mut: MutationTypes, msg: any) => {
  // console.log(mut + ' ' + msg)
}
